<div id="modal-content-wrapper" [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
  <header id="modal-header">
<!--    <h1 id="addEditDel-title">{{ modalData.title|translate }}</h1>-->
  </header>
  <section id="modal-body">
<!------------------------------------------------delete------------------------------------------>
    <div *ngIf="modalData.name ==='delete'" style="min-height: 100px">
      <p >{{ modalData.description | translate}}</p>
    </div>

    <!------------------------------------------------edit------------------------------------------>
      <div class=" card card-user" *ngIf="modalData.name ==='edit'">
        <div class=" card-body">
            <div class="row col-12 pb-5 pt-2"
                 [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">

                <div class="row col-12 mx-auto">
                  <div class=" mb-2 mx-auto text-center" *ngIf="modalData.pic">
                    <a href="javascript:void(0)">
                      <img class="mx-auto uploadedFileLogo" [src]="modalData.url? modalData.url: '../../../../assets/img/default.png'"> <br/>
                      <label mat-menu-item for="file" class="btn mt-1" style="height: 29px">
                        {{'Button.SelectFile'|translate}}</label>
                      <input type="file" value="select file"
                             id="file"
                             style="visibility:hidden;display: contents"
                             multiple=""
                             (change)="onSelectFile($event);"
                             #file>
                    </a>
                  </div>

                  <div class="row col-lg-12 mb-3 mx-auto">
                    <div class="col-lg-6 col-md-6 col-12" *ngFor="let item of modalData.languages; let i = index">
                      <mat-form-field class="example-full-width"
                                      [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
                        <mat-label>{{item.languageName}}</mat-label>
                        <input matInput [(ngModel)]="item.content" style="width: 100%"
                               [ngModelOptions]="{standalone: true}">
                      </mat-form-field>

                    </div>
                  </div>
                </div>


            </div>
        </div>

      </div>


  </section>
  <footer class="row d-flex justify-content-end px-5" >
    <input type="input" style="width: 0;height: 0; border: none;outline: none;background: transparent" autofocus/>
    <button   class="btn mx-1" (click)="closeModal()">
      {{'Button.Close'|translate}}
    </button>
    <button  class="btn mx-1" (click)="actionFunction()">
      {{ modalData.actionButtonText |translate}}
    </button>

  </footer>
</div>


